/**
 * 按年统计
 */
import React, { Component } from 'react';
import { Button, Col, Form, message, Row, Select, Table } from 'antd';
import { connect } from 'react-redux';

import { queryAnalysisOperationalDetail } from '@api/finance/budget';
import { saveIncomeInfo } from '@store/modules/income_info';
import util from '@util';
import getAllType from '@util/getAllType';
import LocalDb from '@util/localDb';
import {
  queryFinanceBooksOrg,
  queryFinanceOperationalStatisticsDetail,
} from '@api/finance/finance';
import { BackBtn } from '@comm/BackBtn';

const FormItem = Form.Item;
const { Option } = Select;
const date = new Date();

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      type: [],
      ignoreArr: [],
      year: LocalDb.get('year') || date.getFullYear(),
    };
  }

  componentWillMount() {
    this.loadOrg();
    getAllType().then(res => {
      this.setState({
        type: res,
      });
    });
    this.company = this.props.location.query.companyName;
  }

  componentDidMount() {
    this.loadData(this.state.year);
  }

  /**
   * 获取资金统计列表
   */
  loadData = () => {
    const params = {};
    const { isBalance } = this.props.location.query;
    this.setState({
      isLoading: true,
    });

    params.bookUuid = this.props.params.uuid;
    params.year = this.year || this.state.year;
    params.groupUuids = this.props.params.uuid;

    isBalance
      ? delete params.bookUuid &&
        queryAnalysisOperationalDetail(params).then(res => {
          if (res.statusCode === 200) {
            const ignoreArr = res.data.ignore;
            const data = [];
            ignoreArr.map((item, index) => {
              const dataItem = {};
              Object.keys(item).forEach(key => {
                if (key !== 'type') {
                  const igItem = item[key] && item[key] !== '0' ? item[key] : '-';
                  dataItem[key] = `${igItem}`;
                } else if (key === 'type') {
                  dataItem[key] = item[key];
                }
              });
              data.push(dataItem);
              return ignoreArr;
            });
            this.setState({
              isLoading: false,
              ignoreArr,
            });
          } else {
            message.error(res.message);
          }
        })
      : delete params.groupUuids &&
        queryFinanceOperationalStatisticsDetail(params).then(res => {
          if (res.statusCode === 200) {
            const ignoreArr = res.data.ignore;
            const data = [];
            ignoreArr.map((item, index) => {
              const dataItem = {};
              Object.keys(item).forEach(key => {
                if (key !== 'type') {
                  const igItem = item[key] && item[key] !== '0' ? item[key] : '-';
                  dataItem[key] = `${igItem}`;
                } else if (key === 'type') {
                  dataItem[key] = item[key];
                }
              });
              data.push(dataItem);
              return ignoreArr;
            });
            this.setState({
              isLoading: false,
              ignoreArr,
            });
          } else {
            message.error(res.message);
          }
        });
  };

  /**
   * 获取账号列表
   */
  loadOrg = () => {
    queryFinanceBooksOrg().then(res => {});
  };

  handleSubmit = e => {
    if (e) {
      e.preventDefault();
    }

    const { year } = this.props.form.getFieldsValue();
    this.setState({
      year,
    });
    this.year = year;
    LocalDb.set('year', year);
    this.loadData();
  };

  toDetail = (uuid, igNore, typeUid, yearMonth) => {
    // igNore:0不忽略，1忽略
    const { dispatch } = this.props;
    const { type } = this.state;
    let types = [];
    let notTo = false;
    type.forEach((item, index) => {
      if (item.value === typeUid) {
        types = item.children || [typeUid];
        const b = item.notTo;
        notTo = b;
      }
    });
    dispatch(
      saveIncomeInfo({
        isShowPart: true,
        igNore,
        types,
        yearMonth,
      }),
    );
    if (!notTo) {
      if (types.every(item => item.indexOf('2') === 0)) {
        this.props.router.push(`/finance/operational/${uuid}/buddget`);
      } else {
        this.props.router.push(`/finance/statis/${uuid}/detail`);
      }
    }
  };

  searchBar = () => {
    const { getFieldDecorator } = this.props.form;
    const year = date.getFullYear();
    const years = [];
    for (let i = year; i >= 2014; i--) {
      years.push(i.toString());
    }
    return (
      <Form onSubmit={this.handleSubmit}>
        <Row type="flex" justify="end">
          <Col>
            <FormItem style={{ marginBottom: '16px' }}>
              {getFieldDecorator('year', {
                initialValue: this.state.year,
              })(
                <Select style={{ width: '200px' }}>
                  {years.map((item, index) => {
                    return <Option key={item}>{item}</Option>;
                  })}
                </Select>,
              )}
            </FormItem>
          </Col>
          <Col>
            <FormItem style={{ marginBottom: '16px' }}>
              <Button type="primary" htmlType="submit" style={{ marginLeft: '10px' }}>
                搜索
              </Button>
            </FormItem>
          </Col>
        </Row>
      </Form>
    );
  };

  columns = () => {
    const { type, year } = this.state;
    this.month = [
      { title: `${year}-01`, uuid: '01' },
      { title: `${year}-02`, uuid: '02' },
      { title: `${year}-03`, uuid: '03' },
      { title: `${year}-04`, uuid: '04' },
      { title: `${year}-05`, uuid: '05' },
      { title: `${year}-06`, uuid: '06' },
      { title: `${year}-07`, uuid: '07' },
      { title: `${year}-08`, uuid: '08' },
      { title: `${year}-09`, uuid: '09' },
      { title: `${year}-10`, uuid: '10' },
      { title: `${year}-11`, uuid: '11' },
      { title: `${year}-12`, uuid: '12' },
    ];
    const columns = this.month.map((item, index) => {
      const config = {};
      config.title = item.title;
      config.dataIndex = item.uuid;
      config.key = item.uuid;
      config.width = 200;
      config.render = (text, record) => {
        if (text === 0) {
          return <span>-</span>;
        }
        return (
          <a onClick={() => this.toDetail(item.uuid, 0, record.type)}>
            {util.numberFormat(text, 2, '.', ',')}
          </a>
        );
      };
      return config;
    });
    columns.unshift({
      title: '',
      dataIndex: 'type',
      key: 'type',
      width: 200,
      fixed: 'left',
      render: (text, record) => {
        let typeName = '';
        const style = {};
        if (type.length > 0) {
          type.forEach((item, index) => {
            if (text === item.value) {
              typeName = item.key;
              if (item.color) {
                style.color = item.color;
              }
              return typeName;
            }
          });
        }

        return <span style={style}>{typeName}</span>;
      },
    });
    columns.push({
      title: '合计',
      dataIndex: 'sum',
      key: 'sum',
      width: 200,
      fixed: 'right',
      render: (text, record) => {
        return <span style={{ color: '#108ee7' }}>{util.numberFormat(text, 2, '.', ',')}</span>;
      },
    });
    return columns;
  };

  render() {
    const { ignoreArr, isLoading, year } = this.state;
    return (
      <div className="statis-box">
        <Row type="flex" justify="space-between">
          <Col>
            <BackBtn />
          </Col>
          <Col style={{ textAlign: 'right' }} span={12}>
            {this.searchBar()}
          </Col>
        </Row>
        <Table
          id="table-to-xls"
          columns={this.columns()}
          dataSource={ignoreArr}
          loading={isLoading}
          scroll={{ x: 2800, y: util.pageHeight() - 168 }}
          bordered
          size="small"
          rowKey={record => record.type}
          title={() => (
            <p style={{ textAlign: 'Center' }}>{`${this.company}-${year}年运营数字分析`}</p>
          )}
          pagination={false}
        />
      </div>
    );
  }
}

export default connect(state => ({
  list: state.contract_type,
  account_info: state.account_info,
}))(Form.create()(Index));



// WEBPACK FOOTER //
// ./src/components/finance/operational/PageYear.js